import React from 'react'
import { Button } from 'reactstrap'
import { keyframes, styled } from '@mui/material/styles'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import AssistantDrawer from '../Assistant/AssistantDrawer'
import { withFirebase } from '../Fb'

// Once every 30 seconds a band of the Apuri colours slides across the button, to catch the admin's
// eye; the rest of the cycle it is an ordinary button. 1.5 s of sweep = 5 % of the 30 s cycle.
const sweep = keyframes`
  0% { background-position: 130% 0; }
  5%, 100% { background-position: -30% 0; }
`

const ShimmerButton = styled(Button)({
  backgroundImage: 'linear-gradient(110deg, transparent 35%, rgba(66,133,244,0.85) 45%, rgba(155,114,203,0.85) 50%, rgba(217,101,112,0.85) 55%, transparent 65%)',
  backgroundSize: '300% 100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '-30% 0',
  animation: `${sweep} 30s ease-in-out 3s infinite`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
})

function AssistantButton({ firebase, iconOnly }) {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <AssistantDrawer firebase={firebase} open={open} onClose={() => setOpen(false)} />
      <ShimmerButton size='sm' onClick={() => setOpen(true)} style={{ marginRight: 10 }} title={iconOnly ? 'Apuri' : undefined}>
        <AutoAwesomeIcon fontSize='small' />{iconOnly ? '' : ' Apuri'}
      </ShimmerButton>
    </>
  )
}

export default withFirebase(AssistantButton)
